import { Tween } from '@tweenjs/tween.js';
import { degToRad } from 'three/src/math/MathUtils';
import { Rotation, Sweep } from '@/_models/Sweep';

export class VRCameraController {
  THREE: any;

  renderer: any;

  camera: any;

  cameraPose: any;

  baseReferenceSpace: any;

  constructor(THREE, renderer, camera, cameraPose) {
    this.THREE = THREE;
    this.renderer = renderer;
    this.camera = camera;
    this.cameraPose = cameraPose;
  }


  // Apply rotation directly to VR camera using the rotation values
  rotateVRViewByCameraRotation(rotation: Rotation) {
    // Always get a fresh reference space to avoid conflicts
    const freshBaseReferenceSpace = this.renderer.xr.getReferenceSpace();

    // Reset reference space first
    const resetTransform = new XRRigidTransform(new this.THREE.Vector3(), {
      x: 0,
      y: 0,
      z: 0,
      w: 1,
    });
    const resetSpaceOffset = freshBaseReferenceSpace.getOffsetReferenceSpace(resetTransform);
    this.renderer.xr.setReferenceSpace(resetSpaceOffset);

    // Apply the rotation directly using quaternion
    setTimeout(() => {
      // Use the Matterport SDK camera rotation, not the VR camera
      const currentMPRotation = this.cameraPose.current.rotation;

      // Calculate the rotation difference from current MP camera rotation to target rotation
      const currentYaw = currentMPRotation.y;


      const targetYaw = rotation.y;

      // Calculate the difference (yaw only)
      let yawDifference = targetYaw - currentYaw;

      // Normalize yaw difference to [-180, 180] range
      while (yawDifference > 180) yawDifference -= 360;
      while (yawDifference < -180) yawDifference += 360;

      // Invert yaw direction for VR coordinate system
      yawDifference = -yawDifference;

      // Create quaternion from the rotation difference, ensuring no roll
      const quaternion = new this.THREE.Quaternion();

      // Apply only yaw rotation first
      const yawQuaternion = new this.THREE.Quaternion();
      yawQuaternion.setFromAxisAngle(new this.THREE.Vector3(0, 1, 0), this.THREE.MathUtils.degToRad(yawDifference));

      // Do not apply pitch to reference space to keep world level (avoid roll)
      quaternion.copy(yawQuaternion);

      const transform = new XRRigidTransform(new this.THREE.Vector3(), {
        x: quaternion.x,
        y: quaternion.y,
        z: quaternion.z,
        w: quaternion.w,
      });
      const rotationSpaceOffset = freshBaseReferenceSpace.getOffsetReferenceSpace(transform);
      this.renderer.xr.setReferenceSpace(rotationSpaceOffset);
    }, 300);
  }

  getDirectionFromRotation(rotationX: number, rotationY: number) {
    const forward = new this.THREE.Vector3(0, 0, -1);
    const euler = new this.THREE.Euler(
      this.THREE.MathUtils.degToRad(rotationX),
      this.THREE.MathUtils.degToRad(rotationY),
      0,
      'YXZ',
    );
    forward.applyEuler(euler);
    return forward;
  }
}
